function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 250,
    viewBox: "0 0 200 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25 184.55L100 222.05V25H25V184.55ZM25 0H175C181.63 0 187.989 2.63392 192.678 7.32233C197.366 12.0107 200 18.3696 200 25V200L100 250L0 200V25C0 18.3696 2.63392 12.0107 7.32233 7.32233C12.0107 2.63392 18.3696 0 25 0Z",
    fill: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 184.55L100 222.05V25H25V184.55ZM25 0H175C181.63 0 187.989 2.63392 192.678 7.32233C197.366 12.0107 200 18.3696 200 25V200L100 250L0 200V25C0 18.3696 2.63392 12.0107 7.32233 7.32233C12.0107 2.63392 18.3696 0 25 0Z",
    fill: "white",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeShield);
export default __webpack_public_path__ + "static/media/feShield.abf291843ef31170d28fc5e7fbeff87e.svg";
export { ForwardRef as ReactComponent };